/**
 * MagnifyingGlass search input matching PipelineToolbar search chrome.
 */
import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { toolbarSearchInput } from './listToolbarTokens';

export type ListSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  'aria-label': string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
};

const ListSearchInput: React.FC<ListSearchInputProps> = ({
  value,
  onChange,
  placeholder,
  'aria-label': ariaLabel,
  className = '',
  inputClassName = '',
  disabled = false,
}) => {
  return (
    <div className={`flex-1 min-w-0 relative ${className}`}>
      <MagnifyingGlassIcon
        className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
        aria-hidden
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-label={ariaLabel}
        disabled={disabled}
        className={`${toolbarSearchInput} ${inputClassName} ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
      />
    </div>
  );
};

export default ListSearchInput;
